import Offers from './offers';
import Auth from './auth';
import GiftCards from './gift-cards';
import DiscountExclusivity from './discount-exclusivity';

export default {
  Offers,
  Auth,
  GiftCards,
  DiscountExclusivity,
};
